module.exports = __webpack_public_path__ + "static/media/paypal.8469b83b.png";